import { render, staticRenderFns } from "./electric-meter.vue?vue&type=template&id=5b51cd7f&scoped=true"
import script from "./electric-meter.vue?vue&type=script&lang=js"
export * from "./electric-meter.vue?vue&type=script&lang=js"
import style0 from "./electric-meter.vue?vue&type=style&index=0&id=5b51cd7f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b51cd7f",
  null
  
)

export default component.exports